import { AxiosInstance } from "axios";
import { ApiRouteHelpers as Helpers } from "../../../root/apiRoutes";

export interface ChildOrganization {
  name: string;
  publicId: string;
}

export class OrganizationVendorClientController {
  constructor(private axios: AxiosInstance) {}

  public getChildOrganizations = async (organizationId: string): Promise<ChildOrganization[]> => {
    const url = Helpers.organization.childOrgs(organizationId);
    const response = await this.axios.get<ChildOrganization[]>(url);

    return response.data;
  };
}
